import styled from 'styled-components';
import { colors } from '../colors';

interface inputProps {
	borderColor?: string;
	floatingInput?: boolean;
}

const Input = styled.input<inputProps>`
	display: inline-block;
	width: 100%;
	background: ${colors.White};
	border: 1px solid ${colors.GreyA0};
	border-radius: 5px;
	height: 36px;
	padding: 6px 16px;
	font-size: 14px;
	transition: ease-in all 0.4s;
	box-sizing: border-box;
	color: ${colors.Grey};
	border-color: ${({ borderColor }) => borderColor}!important;
	:focus {
		outline: none;
		border: 1px solid ${colors.BlueDark};
	}
	${({ floatingInput }) =>
		floatingInput &&
		`font-size: 15px!important;
		line-height: 18px!important;
		height: 48px;
		 transition: background-color 5000s ease-in-out 0s;
		padding: 16px;
		border: 1px solid ${colors.BorderColorTB};
		border-radius: 6px;
		&:focus + label, &:not(:placeholder-shown) ~ label{
            position: absolute;
            top: -6px;
            left: 12px;
			opacity: 1;
            font-size: 12px!important;
            line-height: 14px;
            background: ${colors.White};
            width: auto;
            padding:0 5px;
            color: ${colors.GreyA0}
		  }
		  &:not(:placeholder-shown) ~ label{
			color: ${colors.GreyA0};
		  }
		  &:focus, &:not(:placeholder-shown){
			border-color: ${colors.GreyA0};
		}
		
	`}
`;

export default Input;
